<template>
    <div class="pt-28 min-h-screen xl:flex">
    <timeline /> 
    </div>
</template>

<script>
import Timeline from "@/components/Timeline.vue"

export default {
    components : {
        Timeline
    }
}
</script>
